// material-ui
import {styled, Theme} from '@mui/material/styles';
import Box from '@mui/material/Box';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

interface Props {
    theme: Theme;
    open: boolean;
}

export const DrawerHeaderStyled = styled(Box, {shouldForwardProp: prop => prop !== 'open'})(({theme, open}: Props) => ({
    ...theme.mixins.toolbar,
    display: 'flex',
    alignItems: 'center',
    justifyContent: open ? 'flex-start' : 'center',
}));

export default DrawerHeaderStyled;
